module.exports = __webpack_public_path__ + "img/stock3.82772e46.png";